import { toast } from "sonner";

const NAMES = {
  first_step: "First Step", money_rookie: "Money Rookie", simulator: "Life Simulator",
  streak_3: "On Fire", level_5: "Rising Adult", coach_talk: "Mentored", challenger: "Challenger",
};
export const badgeName = (id) => NAMES[id] || id;

const celebrate = (detail) => window.dispatchEvent(new CustomEvent("lp:celebrate", { detail }));

export function showRewards(res) {
  if (!res) return;
  if (res.xp_gained > 0) {
    toast.success(`+${res.xp_gained} Life XP`, { description: res.coins_gained ? `+${res.coins_gained} coins earned` : undefined });
  }
  // Level up = big celebration overlay
  if (res.leveled_up) {
    celebrate({ type: "level", title: `Level ${res.new_level}`, subtitle: "You leveled up your adulthood!" });
  }
  // Badges = celebration overlay (staggered after level-up)
  (res.new_badges || []).forEach((b, i) => {
    setTimeout(() => celebrate({ type: "badge", title: badgeName(b), subtitle: "Badge unlocked" }), res.leveled_up ? 3400 + i * 3400 : i * 3400);
  });
}
